import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import { withRouter } from 'react-router';
import Ad from '../../../../components/ad/ad';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import Slug from '../../../../components/slug/slug';
import { isAdvertorial } from '../../../../components/advertorial/advertorial';
import IBDCategory from '../../../../components/ibd_category/ibd_category';
import matchMediaDesktop from '../../../../../utils/client_util';
import FranchiseIntro from '../../../../components/franchise_intro/franchise_intro';
import scrollToEl from '../../../../../utils/scroll_to_el_util';

class InnovationByDesign extends Component {
  componentDidMount() {
    this.isDesktop = matchMediaDesktop('64em');
  }

  componentDidUpdate() {
    scrollToEl('.ibd-category--active', 150);
  }

  render() {
    if (this.props.innovationByDesignPage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }
    if (this.props.innovationByDesignPage.isLoading) {
      return (
        <section className="innovation-by-design-page">
          <article className="innovation-by-design-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(this.props, 'innovationByDesignPage.ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const { innovationByDesign } = this.props;

    const year = get(this.props.match, 'params.year');
    const category = get(this.props.match, 'params.category');
    const tags = get(this.props, 'tagAllFeed.posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const pgTitle = `Innovation By Design Awards ${year}`;
    const sectionTitle = `Innovation By Design ${year} Categories`;

    const poster =
      'https://images.fastcompany.net/image/upload/w_387,h_218,c_fill,q_auto,f_auto,fl_lossy/v1498077352/fcweb/ibd_a2ubg2.jpg';
    let encodedText = encodeURIComponent(
      `Innovation By Design Awards ${year} #IBDawards${year}`
    );
    const uri = `https://www.fastcodesign.com/innovation-by-design/${year}`;

    // TODO: This solution is temporary. It needs some work to make sure the text is correct for each year.
    let specialText = '';
    if (parseInt(year, 10) === 2017) {
      encodedText =
        "Fast Company's sixth annual Innovation By Design Awards are now announced. Read on for this year's " +
        'best products, services, interfaces, and ideas.';
      specialText =
        "The %23FCDesignAwards include this year's best products, services, interfaces, and ideas. Be " +
        'inspired by @FastCompany:';
    }

    return (
      <section
        className={`innovation-by-design-page ${
          advertorial ? 'innovation-by-design-page--advertorial' : ''
        }`}
      >
        <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />

        <div className="ad-container ad-container--gray ad-container--hide-for-small">
          <Ad {...combinedAdModel} name="flexiblebillboard_1" />
        </div>

        <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
          <Ad {...combinedAdModel} name="mobileleaderboard" />
        </div>

        <FranchiseIntro
          poster={poster}
          title={pgTitle}
          desc={this.props.innovationByDesignYearDetail}
          social={{
            enableSticky: false,
            modifier: 'feature-feed',
            text: '',
            socialText: {
              twitter: specialText,
              linkedin: encodedText,
              email: encodedText
            },
            uri
          }}
        />

        <section className="ibd-list">
          <Slug slugName={sectionTitle} className="ibd-list" />
        </section>

        <section className="innovation-by-design-page__category-container">
          {innovationByDesign.map((cat, idx) => (
            <IBDCategory
              combinedAdModel={combinedAdModel}
              category={cat}
              key={get(cat, 'category_name')}
              index={String(idx)}
              year={year}
              active={category === get(cat, 'url')}
            />
          ))}
        </section>
        <div className="ad-container">
          <Ad {...combinedAdModel} name="flexiblebillboard_2" />
          <Ad {...combinedAdModel} name="mobilerectangle_1" />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  const ibdData = get(state, 'innovationByDesign.data.rows');
  const ibdYearDetail = get(
    state,
    'innovationByDesignDetail.data.rows[0].body'
  );

  return {
    config: state.config || {},
    status: state.status.code,
    innovationByDesignPage: get(state, 'innovationByDesignPage') || {
      error: true
    },
    innovationByDesign: ibdData || [],
    innovationByDesignYearDetail: ibdYearDetail || ''
  };
}

InnovationByDesign.defaultProps = {
  status: 200
};

InnovationByDesign.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  match: PropTypes.shape({}).isRequired,
  innovationByDesignPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  innovationByDesign: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  innovationByDesignYearDetail: PropTypes.string.isRequired
};

export default withRouter(connect(mapStateToProps)(InnovationByDesign));



// WEBPACK FOOTER //
// ./src/views/containers/pages/ibd/innovation_by_design_page/innovation_by_design_page.js